import React from "react";
import { Link } from "react-router-dom";
import { Twitter, Youtube, Github, ShieldCheck } from "lucide-react";
import ComingSoonBanner from "./ComingSoonBanner";

const WORDMARK_URL = "/logo-wordmark.png";

const POLICIES = [
  { label: "About Us", href: "/about" },
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Terms of Use", href: "/terms-of-use" },
  { label: "Editorial Policy", href: "/editorial-policy" },
  { label: "Financial Disclaimer", href: "/financial-disclaimer" },
  { label: "Market Data & Sources", href: "/market-data-sources" },
  { label: "Advertising & Sponsorship", href: "/advertising-sponsorship" },
  { label: "Corrections & Feedback", href: "/corrections-feedback" },
  { label: "Contact Us", href: "/contact-us" },
];

export default function Footer() {
  const scrollTop = () => window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  return (
    <footer className="mt-16">
      <ComingSoonBanner />
      <div className="border-t border-slate-200 bg-white">
        <div className="px-4 sm:px-6 lg:px-12 py-10 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" onClick={scrollTop} className="block" data-testid="footer-logo">
              <img src={WORDMARK_URL} alt="Nivesh Street" className="h-[100px] md:h-32 w-auto object-contain mb-3 mix-blend-multiply" />
            </Link>
            <p className="text-xs text-slate-600 leading-relaxed">India's live market intelligence hub. Real-time NSE / BSE prices, IPO analysis, DRHP repository, commodities, crypto, real estate and market mood tracking.</p>
          </div>
          <div>
            <div className="text-xs font-mono-fin uppercase tracking-widest text-[#D91E2A] mb-3 font-semibold">Markets</div>
            <ul className="space-y-2 text-sm text-slate-600">
              <li><Link to="/" onClick={scrollTop} className="hover:text-slate-900">Home</Link></li>
              <li><Link to="/news" onClick={scrollTop} className="hover:text-slate-900">Live News</Link></li>
              <li><Link to="/commodities" onClick={scrollTop} className="hover:text-slate-900">Commodities</Link></li>
              <li><Link to="/crypto" onClick={scrollTop} className="hover:text-slate-900">Crypto</Link></li>
              <li><Link to="/real-estate" onClick={scrollTop} className="hover:text-slate-900">Real Estate</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-xs font-mono-fin uppercase tracking-widest text-[#D91E2A] mb-3 font-semibold">Research</div>
            <ul className="space-y-2 text-sm text-slate-600">
              <li><Link to="/ipos" onClick={scrollTop} className="hover:text-slate-900">IPO Hub</Link></li>
              <li><Link to="/drhp" onClick={scrollTop} className="hover:text-slate-900">DRHP Vault</Link></li>
              <li><Link to="/watchlist" onClick={scrollTop} className="hover:text-slate-900">Watchlist</Link></li>
              <li><Link to="/blogs" onClick={scrollTop} className="hover:text-slate-900">Editorial</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-xs font-mono-fin uppercase tracking-widest text-[#D91E2A] mb-3 font-semibold">Follow</div>
            <div className="flex gap-2">
              <a href="#" className="p-2 rounded-md border border-slate-300 hover:border-[#D91E2A] hover:text-[#D91E2A]"><Twitter className="w-4 h-4" /></a>
              <a href="#" className="p-2 rounded-md border border-slate-300 hover:border-[#D91E2A] hover:text-[#D91E2A]"><Youtube className="w-4 h-4" /></a>
              <a href="#" className="p-2 rounded-md border border-slate-300 hover:border-[#D91E2A] hover:text-[#D91E2A]"><Github className="w-4 h-4" /></a>
            </div>
          </div>
        </div>
        {/* Legal & policy links — single compact horizontal row */}
        <div className="border-t border-slate-200 px-4 sm:px-6 lg:px-12 py-2.5 flex flex-wrap items-center gap-x-1 gap-y-1 text-[10px] text-slate-500 bg-white" data-testid="footer-policies">
          {POLICIES.map((p, i) => (
            <span key={p.label} className="inline-flex items-center">
              {i > 0 && <span className="mx-1.5 text-slate-300">·</span>}
              <Link
                to={p.href}
                onClick={scrollTop}
                className="hover:text-[#D91E2A] transition-colors"
                data-testid={`footer-policy-${p.href.replace('/','')}`}
              >
                {p.label}
              </Link>
            </span>
          ))}
        </div>
        <div className="border-t border-slate-200 px-6 lg:px-12 py-4 pr-20 text-[11px] text-slate-500 flex flex-wrap gap-3 items-center bg-white">
          <span>© 2026 Nivesh Street. Data via public exchange feeds & RSS aggregators. Educational content only — not investment advice.</span>
          <Link to="/admin/login" data-testid="footer-admin-login" className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-slate-300 text-slate-600 hover:text-[#D91E2A] hover:border-[#D91E2A] transition-colors font-semibold">
            <ShieldCheck className="w-3.5 h-3.5" /> Editor Access
          </Link>
        </div>
      </div>
    </footer>
  );
}
